import { Text } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledText = styled(Text)`
  white-space: nowrap;
`
